// ==================================
// 読み込み
// ==================================

// import Splide JS
import Splide from "@splidejs/splide";

// デフォルトのテーマ
import "@splidejs/splide/css";

export default function initSplide() {
  // ==================================
  // ホームMV
  // ==================================

  function _initHmMvSlider() {
    const hmMvSlide = document.querySelector(".js-hm-mv-slider");

    if (!hmMvSlide) return;

    const slider = new Splide(".js-hm-mv-slider", {
      autoplay: true,
      arrows: true,
      pagination: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      type: "loop",
      focus: "center",
      interval: 4000,
      speed: 1500,
      gap: 30,
      perPage: 1,
      fixedWidth: "90%",

      classes: {
        pagination: "splide__pagination pg-hm-mv-slider__pagination",
      },

      breakpoints: {
        768: {
          fixedWidth: "95%",
        },
      },
    });

    slider.mount();
  }

  _initHmMvSlider();
}

export { initSplide };
